export default "__VITE_ASSET__DPa8OBFT__"